"use client";
import Logo from "@/assets/images/icons/logo.svg";
import LangSwitcher from "@/components/header/LocaleSwitcher";
import { TadbeerLogo } from "@/components/ui/TadbeerLogo";
import { ThemeEnum } from "@/constants/theme";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

import useThemeStore from "../../../store/useThemeStore";

export const Header = () => {
  const t = useTranslations("Accessibility");
  const { theme } = useThemeStore();

  return (
    <header
      className={`md:h-22 flex items-center justify-between bg-white px-4 dark:bg-primary lg:px-6 2xl:h-32 2xl:px-12 3xl:px-[7.5rem]`}
    >
      <div className="flex h-16 w-full items-center justify-between lg:h-20 4xl:mx-auto 4xl:max-w-[1680px]">
        {theme && theme !== ThemeEnum.TADBEER && (
          <Image
            alt={t("logoAlt")}
            className="md:w-[8,31rem ] w-[70px] cursor-pointer xl:h-[5.313rem] xl:w-28"
            priority
            src={Logo}
          />
        )}{" "}
        {theme === ThemeEnum.TADBEER && <TadbeerLogo />}
        <LangSwitcher />
      </div>
    </header>
  );
};
